import { useEffect, useState } from "react";
import { Asset } from "../types";
import { Permissions } from "../types/UploadAssetModalProps";

export default function usePermissions(assetItems: Asset[], folderUid: string, permissions: Permissions) {
  const [isCreateAllowed, setIsCreateAllowed] = useState(true);
  useEffect(() => {
    let parentFolder = undefined;
    if (folderUid !== 'cs_root') {
      parentFolder = assetItems.find((asset) => asset.uid === folderUid);
    }
    // Fallback for 'permissions' prop not provided
    const isAllowed = permissions ? permissions.create(parentFolder) : true;
    setIsCreateAllowed(isAllowed);
  }, [folderUid]);
  return { isCreateAllowed };
}
